import Reactotron from "reactotron-react-js";

Reactotron.configure() // You can pass { host: 'your-ip' } if needed
  .connect(); // Connect to Reactotron app

console.tron = Reactotron;

export default Reactotron;
